import { Badge } from "@/components/ui/badge";

export function PhaseBadge({ phase = 2, label }) {
    return (
        <Badge
            data-testid={`phase-badge-${phase}`}
            variant="outline"
            className="border-zinc-300 bg-zinc-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-zinc-500 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-400"
        >
            {label || `Phase ${phase}`}
        </Badge>
    );
}
